import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/doctocat/doctocat/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { ThemeContext } from 'styled-components';
import { style } from 'styled-system';
var oppositeEdge = {
  top: 'Bottom',
  right: 'Left',
  bottom: 'Top',
  left: 'Right'
};
var perpendicularEdge = {
  top: 'Left',
  right: 'Top',
  bottom: 'Left',
  left: 'Top'
};

function getEdgeAlign(location) {
  var _location$split = location.split('-'),
      _location$split2 = _slicedToArray(_location$split, 2),
      edge = _location$split2[0],
      align = _location$split2[1];

  return [edge, align];
}

function getPosition(edge, align, spacing) {
  var _ref;

  var opposite = oppositeEdge[edge].toLowerCase();
  var perp = perpendicularEdge[edge].toLowerCase();
  return _ref = {}, _defineProperty(_ref, opposite, '100%'), _defineProperty(_ref, align || perp, align ? spacing : '50%'), _ref;
}

var getBg = style({
  prop: 'bg',
  key: 'colors'
});
var getBorderColor = style({
  prop: 'borderColor',
  key: 'colors'
});
var getBorderWidth = style({
  prop: 'borderWidth',
  key: 'borderWidths',
  scale: [0, 1]
});

function Caret(props) {
  var _props$theme;

  var theme = React.useContext(ThemeContext);

  var propsWithTheme = _objectSpread(_objectSpread({}, props), {}, {
    theme: (_props$theme = props.theme) !== null && _props$theme !== void 0 ? _props$theme : theme
  });

  var _getBg = getBg(propsWithTheme),
      bg = _getBg.bg;

  var _getBorderColor = getBorderColor(propsWithTheme),
      borderColor = _getBorderColor.borderColor;

  var _getBorderWidth = getBorderWidth(propsWithTheme),
      borderWidth = _getBorderWidth.borderWidth;

  var _props$size = props.size,
      size = _props$size === void 0 ? 8 : _props$size,
      _props$location = props.location,
      location = _props$location === void 0 ? 'bottom' : _props$location;

  var _getEdgeAlign = getEdgeAlign(location),
      _getEdgeAlign2 = _slicedToArray(_getEdgeAlign, 2),
      edge = _getEdgeAlign2[0],
      align = _getEdgeAlign2[1];

  var perp = perpendicularEdge[edge]; // note: these arrays represent points in the form [x, y]

  var a = [-size, 0];
  var b = [0, size];
  var c = [size, 0]; // spaces are optional in path `d` attribute, and points are
  // represented in the form `x,y` -- which is what the arrays above
  // become when stringified!

  var triangle = "M".concat(a, "L").concat(b, "L").concat(c, "L").concat(a, "Z");
  var line = "M".concat(a, "L").concat(b, "L").concat(c);
  var transform = {
    top: "translate(".concat([size, size * 2], ") rotate(180)"),
    right: "translate(".concat([0, size], ") rotate(-90)"),
    bottom: "translate(".concat([size, 0], ")"),
    left: "translate(".concat([size * 2, size], ") rotate(90)")
  }[edge];
  return /*#__PURE__*/React.createElement("svg", {
    width: size * 2,
    height: size * 2,
    style: _objectSpread(_objectSpread({
      pointerEvents: 'none',
      position: 'absolute'
    }, getPosition(edge, align, size)), {}, _defineProperty({}, "margin".concat(perp), align ? null : -size))
  }, /*#__PURE__*/React.createElement("g", {
    transform: transform
  }, /*#__PURE__*/React.createElement("path", {
    d: triangle,
    fill: bg
  }), /*#__PURE__*/React.createElement("path", {
    d: line,
    fill: "none",
    stroke: borderColor,
    strokeWidth: borderWidth
  })));
}

Caret.displayName = "Caret";
Caret.locations = ['top', 'top-left', 'top-right', 'right', 'right-top', 'right-bottom', 'bottom', 'bottom-left', 'bottom-right', 'left', 'left-top', 'left-bottom'];
Caret.defaultProps = {
  bg: 'canvas.default',
  borderColor: 'border.default',
  borderWidth: 1
};
export default Caret;